import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=b400b8fc&scoped=true&"
import script from "./Notice.vue?vue&type=script&lang=js&"
export * from "./Notice.vue?vue&type=script&lang=js&"
import style0 from "styles/views/notice/notice.css?vue&type=style&index=0&id=b400b8fc&scoped=true&lang=css&"
import style1 from "./Notice.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b400b8fc",
  null
  
)

export default component.exports